var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFullpageError(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 360,
    height: 270,
    viewBox: "0 0 360 270",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M360 0H0V270H360V0Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M102.784 176.569C74.4038 183.343 51.0186 187.316 30.9532 208.597C21.8996 218.262 -1.62379 212.429 10.5361 205.5C27.006 196.137 71.7961 179.127 94.279 176.87L102.784 176.569Z",
    fill: "#050505",
    fillOpacity: 0.04
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M105.141 175.577C69.6765 180.362 36.4555 190.564 10.4121 206.42",
    stroke: "#707070",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M56.2966 205.232C56.2966 205.678 54.5866 206.04 52.4755 206.04C50.3644 206.04 48.6489 205.678 48.6489 205.232C48.6489 204.787 50.3589 204.425 52.4755 204.425C54.5921 204.425 56.2966 204.787 56.2966 205.232Z",
    fill: "#050505",
    fillOpacity: 0.04
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M60.168 191.558C60.6247 194.588 57.2159 197.05 53.5675 197.05C49.9191 197.05 46.9614 194.593 46.9614 191.558C46.9614 188.522 51.5122 179.376 54.2025 183.854C56.2634 187.308 59.4941 186.907 60.1903 191.558",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M60.168 191.558C60.6247 194.588 57.2159 197.05 53.5675 197.05C49.9191 197.05 46.9614 194.593 46.9614 191.558C46.9614 188.522 51.5122 179.376 54.2025 183.854C56.2634 187.308 59.4941 186.907 60.1903 191.558",
    stroke: "#707070",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M53.4116 197.323V204.72",
    stroke: "#707070",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M47.8636 189.592C47.8636 189.592 49.7351 190.266 50.5261 192.967C51.3171 195.669 53.0048 197.195 54.4252 196.721C52.1248 197.356 44.6664 196.766 47.8525 189.592",
    fill: "#050505",
    fillOpacity: 0.04
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M60.168 191.558C60.6247 194.588 57.2159 197.05 53.5675 197.05C49.9191 197.05 46.9614 194.593 46.9614 191.558C46.9614 188.522 51.5122 179.376 54.2025 183.854C56.2411 187.308 59.4717 186.907 60.168 191.558Z",
    stroke: "#707070",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M274.927 228.156C274.927 228.156 277.538 226.332 278.998 228.943C280.458 231.616 279.608 238.422 284.042 237.758C282.458 238.183 279.546 239.218 275.9 236.545C272.316 233.811 272.741 229.554 274.927 228.156Z",
    fill: "#050505",
    fillOpacity: 0.04
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M259.104 208.499C259.104 208.499 261.374 206.836 262.663 209.182C263.952 211.529 263.192 217.501 267.125 216.972C265.693 217.346 263.192 218.261 259.942 215.914C256.769 213.49 257.143 209.711 259.104 208.499Z",
    fill: "#050505",
    fillOpacity: 0.04
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M106.851 238.723C106.851 238.723 51.7863 236.112 41.0955 252.095C37.2634 257.804 24.8734 253.857 35.4403 248.21C46.317 242.378 58.477 236.236 94.6294 237.21L106.843 238.732L106.851 238.723Z",
    fill: "#050505",
    fillOpacity: 0.04
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M231.681 248.688C242.257 250.449 252.647 250.75 261.214 250.874C290.322 250.263 326.846 244.307 334.085 217.271",
    stroke: "#707070",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M32.9536 250.387C48.2111 238.289 77.6198 236.413 100.656 237.139",
    stroke: "#707070",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M249.129 180.732C276.711 186.698 309.361 197.53 328.376 207.606C331.899 209.491 334.094 213.075 334.094 217.023",
    stroke: "#707070",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M291.791 202.925V218.253",
    stroke: "#707070",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M304.128 189.127C302.915 196.482 298.596 202.677 291.791 202.677C284.985 202.677 279.454 196.597 279.454 189.127C279.454 181.658 285.286 160.197 290.268 171.259C294.101 179.764 305.278 182.384 304.128 189.127Z",
    fill: "white"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M313.305 254.157C328.377 245.405 339.74 233.431 339.74 217.147C339.74 213.686 334.395 213.686 334.395 213.686",
    stroke: "#707070",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M333.908 213.562C333.908 213.562 345.519 214.412 350.803 222.129",
    stroke: "#707070",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M286.222 239.842C286.222 240.514 283.611 240.992 280.39 240.992C277.168 240.992 274.558 240.443 274.558 239.842C274.558 239.169 277.168 238.691 280.39 238.691C283.611 238.691 286.222 239.178 286.222 239.842Z",
    fill: "#050505",
    fillOpacity: 0.04
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M290.665 230.664C290.665 235.098 286.594 238.629 281.611 238.629C276.629 238.629 272.558 235.045 272.558 230.664C272.558 226.283 275.841 227.018 281.611 222.699C287.381 218.38 290.665 226.283 290.665 230.664Z",
    stroke: "#707070",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M267.896 218.502C267.896 218.989 265.834 219.414 263.338 219.414C260.842 219.414 258.78 218.989 258.78 218.502C258.78 218.015 260.842 217.591 263.338 217.591C265.834 217.591 267.896 218.015 267.896 218.502Z",
    fill: "#050505",
    fillOpacity: 0.04
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M271.356 211.387C271.356 214.847 268.197 217.582 264.303 217.582C260.409 217.582 257.249 214.785 257.249 211.387C257.249 207.988 260.285 201.546 264.303 205.192C267.462 208.962 271.356 207.927 271.356 211.387Z",
    stroke: "#707070",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M77.3916 220.017C77.3916 220.017 80.0024 218.193 81.4626 220.804C82.9229 223.477 82.0733 230.283 86.5071 229.619C84.9229 230.044 82.0113 231.079 78.365 228.406C74.7807 225.672 75.2056 221.415 77.3916 220.017Z",
    fill: "#050505",
    fillOpacity: 0.04
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M59.9651 221.213C59.9651 221.213 62.2347 219.549 63.5238 221.896C64.8129 224.242 64.0527 230.214 67.9859 229.685C66.5536 230.06 64.0527 230.974 60.8025 228.627C57.6295 226.204 58.004 222.425 59.9651 221.213Z",
    fill: "#050505",
    fillOpacity: 0.04
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M88.6864 231.703C88.6864 232.375 86.0756 232.853 82.8542 232.853C79.6328 232.853 77.022 232.304 77.022 231.703C77.022 231.03 79.6328 230.552 82.8542 230.552C86.0756 230.552 88.6864 231.039 88.6864 231.703Z",
    fill: "#050505",
    fillOpacity: 0.04
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M93.1292 222.525C93.1292 226.959 89.0582 230.49 84.0756 230.49C79.093 230.49 75.022 226.906 75.022 222.525C75.022 218.144 78.3054 218.879 84.0756 214.56C89.8458 210.241 93.1292 218.144 93.1292 222.525Z",
    stroke: "#707070",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M68.7562 231.216C68.7562 231.702 66.6942 232.127 64.1984 232.127C61.7026 232.127 59.6406 231.703 59.6406 231.216C59.6406 230.729 61.7026 230.304 64.1984 230.304C66.6942 230.304 68.7562 230.729 68.7562 231.216Z",
    fill: "#050505",
    fillOpacity: 0.04
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M72.2164 224.1C72.2164 227.561 69.0569 230.295 65.1629 230.295C61.2689 230.295 58.1094 227.499 58.1094 224.1C58.1094 220.702 61.145 214.259 65.1629 217.905C68.3224 221.676 72.2164 220.64 72.2164 224.1Z",
    stroke: "#707070",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M280.191 184.657C280.191 184.657 285.833 186.766 287.466 192.339C289.099 197.911 294.741 202.128 297.661 201.108C292.088 205.186 276.865 200.9 280.191 184.657Z",
    fill: "#050505",
    fillOpacity: 0.04
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M214.3 259.136C214.3 259.623 215.026 260.048 215.937 260.048C216.849 260.048 217.574 259.623 217.574 259.136C217.574 258.649 216.849 258.225 215.937 258.225C215.026 258.225 214.3 258.588 214.3 259.136Z",
    fill: "#050505",
    fillOpacity: 0.04
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M264.506 254.396C264.506 254.759 265.055 255.069 265.656 255.069C266.329 255.069 266.807 254.768 266.807 254.396C266.807 254.025 266.258 253.724 265.656 253.724C265.055 253.724 264.506 254.025 264.506 254.396Z",
    fill: "#050505",
    fillOpacity: 0.04
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M87.2217 244.006C87.2217 244.493 87.9474 244.918 88.859 244.918C89.7706 244.918 90.4963 244.493 90.4963 244.006C90.4963 243.52 89.7706 243.095 88.859 243.095C87.9474 243.095 87.2217 243.52 87.2217 244.006ZM62.6717 246.254C62.6717 246.741 63.8222 247.166 65.2205 247.166C66.6188 247.166 67.7693 246.741 67.7693 246.254C67.7693 245.768 66.6188 245.343 65.2205 245.343C63.8222 245.343 62.6717 245.768 62.6717 246.254ZM75.0087 249.29C75.0087 249.777 76.1592 250.202 77.5575 250.202C78.9558 250.202 80.1063 249.777 80.1063 249.29C80.1063 248.803 78.9558 248.378 77.5575 248.378C76.1592 248.378 75.0087 248.741 75.0087 249.29ZM51.9189 255.547C51.9189 255.972 52.6446 256.335 53.5031 256.335C54.3616 256.335 55.0873 255.972 55.0873 255.547C55.0873 255.122 54.3616 254.759 53.5031 254.759C52.5915 254.759 51.9189 255.122 51.9189 255.547Z",
    fill: "#050505",
    fillOpacity: 0.04
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M204.52 255.791C204.52 256.278 205.671 256.702 207.069 256.702C208.467 256.702 209.618 256.278 209.618 255.791C209.618 255.304 208.467 254.879 207.069 254.879C205.671 254.879 204.52 255.304 204.52 255.791ZM193.768 260.163C193.768 260.649 194.918 261.074 196.316 261.074C197.715 261.074 198.865 260.65 198.865 260.163C198.865 259.676 197.715 259.251 196.316 259.251C194.918 259.251 193.768 259.676 193.768 260.163Z",
    fill: "#050505",
    fillOpacity: 0.04
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M304.128 189.127C302.915 196.482 298.596 202.677 291.791 202.677C284.985 202.677 279.454 196.597 279.454 189.127C279.454 181.658 285.286 160.197 290.268 171.259C294.101 179.764 305.278 182.384 304.128 189.127Z",
    stroke: "#707070",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M233.865 225.263C233.865 228.558 208.854 231.229 178.001 231.229C147.147 231.229 122.138 228.558 122.138 225.263C122.138 221.969 147.147 219.297 178.001 219.297C208.854 219.297 233.865 221.969 233.865 225.263Z",
    fill: "#050505",
    fillOpacity: 0.04
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M99.5811 92.4214L100.025 161.018L146.832 206.45H214.196C216.828 203.721 197.901 201.965 194.178 201.965C194.178 201.965 157.785 197.971 157.785 197.971C148.762 197.971 151.125 198.261 149.388 197.392C149.388 197.392 140.761 189.182 137.464 185.839C132.362 180.666 127.575 175.148 122.181 170.304C118.346 166.86 110.811 158.36 107.834 154.101L107.4 153.377C105.395 136.083 105.246 110.412 103.056 93.1454C102.988 92.6092 102.403 88.0154 101.029 89.2362C100.107 90.0556 99.5811 91.1624 99.5811 92.4214Z",
    fill: "#F96449"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M208.142 51.0258H152.724C151.07 51.0258 149.483 51.6829 148.314 52.8524L109.129 92.0389C107.959 93.2084 107.302 94.7945 107.302 96.4483V151.866C107.302 153.52 107.959 155.106 109.129 156.275L148.314 195.462C149.483 196.631 151.07 197.288 152.724 197.288H208.142C209.796 197.288 211.382 196.631 212.552 195.462L251.738 156.275C252.908 155.106 253.565 153.52 253.565 151.866V96.4483C253.565 94.7944 252.908 93.2083 251.738 92.0388L212.552 52.8523C211.382 51.6828 209.796 51.0258 208.142 51.0258Z",
    stroke: "#141414",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M199.884 146.729C206.486 151.267 216.288 160.011 210.8 163.36C205.219 163.36 180.404 135.837 180.404 135.837C180.404 135.837 162.304 154.874 155.666 160.577C146.33 168.594 138.637 155.897 144.265 149.177C147.99 144.729 169.004 124.438 169.004 124.438L144.265 99.6986C144.265 99.6986 138.417 94.1075 146.689 86.6405C142.444 93.067 188.626 138.991 199.884 146.729Z",
    fill: "#FFDDD1"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M166.303 133.271L147.288 152.2",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M172.027 127.46L168.925 130.562",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M207.177 102.788L188.626 121.679",
    stroke: "#F96449",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M213.366 96.9392L210.253 100.051",
    stroke: "#F96449",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M191.804 124.438L216.544 99.6982C219.691 96.5504 219.691 91.4462 216.544 88.2983C213.396 85.1517 208.293 85.1505 205.144 88.2983L180.404 113.038L155.664 88.2983C152.515 85.1505 147.413 85.1505 144.264 88.2983C141.116 91.4461 141.116 96.5503 144.264 99.6982L169.004 124.438L144.264 149.178C141.116 152.326 141.116 157.429 144.264 160.576C145.838 162.152 147.9 162.938 149.965 162.938C152.027 162.938 154.09 162.15 155.664 160.576L180.404 135.838L205.144 160.576C206.718 162.15 208.78 162.938 210.843 162.938C212.906 162.938 214.97 162.15 216.544 160.576C219.691 157.429 219.691 152.326 216.544 149.178L191.804 124.438Z",
    stroke: "#F96449",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M211.35 42.4459H149.453C147.606 42.4459 145.834 43.1797 144.528 44.486L100.762 88.2533C99.456 89.5595 98.7222 91.331 98.7222 93.1782V155.074C98.7222 156.921 99.456 158.693 100.762 159.999L144.528 203.766C145.834 205.072 147.606 205.806 149.453 205.806H211.35C213.197 205.806 214.969 205.072 216.275 203.766L260.042 159.999C261.348 158.693 262.082 156.921 262.082 155.074V93.1782C262.082 91.331 261.348 89.5594 260.042 88.2532L216.275 44.4859C214.969 43.1797 213.197 42.4459 211.35 42.4459Z",
    stroke: "#141414",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFullpageError);
export default __webpack_public_path__ + "static/media/fullpage-error.ce3770235290d3f32bd4c51007be5093.svg";
export { ForwardRef as ReactComponent };